import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../Context/Auth/AuthContext";

const RoleProtectedRoute = ({ allowedRoles, children }) => {
   const { userState } = useAuth();

   // Check if user is authenticated
   if (!userState.isAuthenticated) {
      return <Navigate to="/" />;
   }

   // Check if user's role is included in the allowedRoles array
   if (!allowedRoles.includes(userState.user?.role)) {
      // Redirect based on actual role
      switch (userState.user?.role) {
         case "admin":
            return <Navigate to="/admin" />;
         case "manager":
            return <Navigate to="/manager" />;
         case "user":
         default:
            return <Navigate to="/main" />;
      }
   }

   // If role matches, render the children
   return children;
};

export default RoleProtectedRoute;
